import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateDictionaryMarkdownState from './dictionaryMarkdown';
import updateDatasetState from './dataset';

const handlers = {
  ...updateDictionaryMarkdownState,
  ...updateDatasetState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
